import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: '5px',
    width: '100%',
  },
  containerCard: {
    display: 'flex',
    marginInline: 30,
  },
  button: {
    // position: 'absolute',
    // right: 0,
    // top: '80px'
  }
}));

export default useStyles;
